import React from "react";
import { Translation } from "react-i18next";

export const ConnectKonjPageConfig = {
  settings: {
    layout: {
      config: {
        rightSidebar: {
          display: false,
        },
        header: {
          display: true,
          showBack: true,
          konjExit: true,
        },
      },
    },
  },
  routes: [
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.connect-members-to-konj")}
        </Translation>
      ),
      path: "/connect-konj",
      exact: true,
      component: React.lazy(() => import("./index")),
    },
    {
      title: <Translation>{(t) => t("navigation.main.sync-konj")}</Translation>,
      path: "/sync-konj",
      exact: true,
      component: React.lazy(() => import("./SyncKonj")),
    },
  ],
};
